import i18next from "i18next"
import * as BikeApi from "features/bike/api/BikeApi"

import {
    HISTORY_SAVED_BIKES,
    HISTORY_PRESAVED_BIKES
} from "services/browserStorage"

/** 
 *  Forcer la traduction en Français
 *  car on se base sur cette langue pour
 *  les retours de l'API sur le filtre du
 *  tableau d'historique.
 */
const fr = i18next.getFixedT("fr")

export const BACKSTOSTORE_REQUEST = fr("history.operation.backtostore-request", { ns: "partner" })
export const BACKSTOSTORE_REQUEST_REFUSED = fr("history.operation.backtostore-refused", { ns: "partner" })
export const BACKSTOSTORE_REQUEST_ACCEPTED = fr("history.operation.backtostore-accepted", { ns: "partner" })
export const BACKSTOSTORE_REQUEST_FORCED = fr("history.operation.backtostore-forced", { ns: "partner" })
const AUTOMATIC_BACKSTOSTORE_REQUEST_REFUSED = fr("history.operation.automatic-backtostore-refused", { ns: "partner" })

export const BUY_REQUEST = fr("history.operation.buy-request", { ns: "partner" })
export const BUY_REQUEST_ACCEPTED = fr("history.operation.buy-accepted", { ns: "partner" })
export const BUY_REQUEST_REFUSED = fr("history.operation.buy-refused", { ns: "partner" })
const AUTOMATIC_BUY_REQUEST_REFUSED = fr("history.operation.automatic-buy-refused", { ns: "partner" })

export const CANCELLED_REQUEST = fr("history.operation.cancel", { ns: "partner" })
const ACTIVATION = fr("history.operation.activation", { ns: "partner" })

export const PORTABILITY_REQUEST = fr("history.operation.portability", { ns: "partner" })
export const PORTABILITY_REQUEST_REFUSED = fr("history.operation.portability-refused", { ns: "partner" })
export const PORTABILITY_REQUEST_ACCEPTED = fr("history.operation.portability-accepted", { ns: "partner" })
export const PORTABILITY_REQUEST_CANCELLED = fr("history.operation.portability-cancelled", { ns: "partner" })

export const historyTypes = {
    // NB: activated, back and second-hand and onGoing come from the same stream
    // but are then filtered
    onGoing: {
        value: "ON-GOING",
        storageName: HISTORY_SAVED_BIKES,
        operationNameList: [
            BACKSTOSTORE_REQUEST,
            BUY_REQUEST,
            BACKSTOSTORE_REQUEST_REFUSED,
            BUY_REQUEST_REFUSED,
            CANCELLED_REQUEST,
            AUTOMATIC_BACKSTOSTORE_REQUEST_REFUSED,
            AUTOMATIC_BUY_REQUEST_REFUSED,
            PORTABILITY_REQUEST,
            PORTABILITY_REQUEST_REFUSED,
            PORTABILITY_REQUEST_CANCELLED
        ],
        label: "partner:history.activity_types.ongoing",
        route: BikeApi.getActivatedBikesHistoryInfos().route,
        getError: BikeApi.getActivatedBikesHistoryInfos().getError,
        routeParam: "created_after",
        dateProperty: "create_date"
    },
    // Pre-registration comes from another route
    preregistered: {
        value: "PRE-SAVED-BIKES",
        storageName: HISTORY_PRESAVED_BIKES,
        label: "partner:history.activity_types.pre_saved",
        route: BikeApi.getPreRegistrationBikesHistoryInfos().route,
        getError: BikeApi.getPreRegistrationBikesHistoryInfos().getError,
        routeParam: "updated_after",
        dateProperty: "modify_date"
    },
    activated: {
        value: "SAVED-BIKES",
        storageName: HISTORY_SAVED_BIKES,
        operationNameList: [
            ACTIVATION,
        ],
        label: "partner:history.activity_types.saved",
        route: BikeApi.getActivatedBikesHistoryInfos().route,
        getError: BikeApi.getActivatedBikesHistoryInfos().getError,
        routeParam: "created_after",
        dateProperty: "create_date"
    },
    backAndBuy: {
        value: "BACK-AND-BUY-BIKES",
        storageName: HISTORY_SAVED_BIKES,
        operationNameList: [
            BACKSTOSTORE_REQUEST_ACCEPTED,
            BUY_REQUEST_ACCEPTED,
            BACKSTOSTORE_REQUEST_FORCED,
            PORTABILITY_REQUEST_ACCEPTED
        ],
        label: "partner:history.activity_types.back_and_buy_to_store",
        route: BikeApi.getActivatedBikesHistoryInfos().route,
        getError: BikeApi.getActivatedBikesHistoryInfos().getError,
        routeParam: "created_after",
        dateProperty: "create_date"
    },
}

export const onGoingHistoryOperationNamesList = [
	{
		id: "all",
		value: historyTypes.onGoing.operationNameList,
		label: "partner:history.on-going-filters.all",
	},
	{
		id: "waiting",
		value: [
            BACKSTOSTORE_REQUEST,
            BUY_REQUEST,
            PORTABILITY_REQUEST,
        ],
		label: "partner:history.on-going-filters.waiting",
	},
	{
		id: "refused",
		value: [
            BACKSTOSTORE_REQUEST_REFUSED,
            BUY_REQUEST_REFUSED,
            AUTOMATIC_BACKSTOSTORE_REQUEST_REFUSED,
            AUTOMATIC_BUY_REQUEST_REFUSED,
            PORTABILITY_REQUEST_REFUSED,
        ],
		label: "partner:history.on-going-filters.refused",
	},
	{
		id: "expired",
		value: [
            BACKSTOSTORE_REQUEST,
            BUY_REQUEST,
            PORTABILITY_REQUEST,
        ],
		label: "partner:history.on-going-filters.expired",
	},
	{
		id: "cancelled",
		value: [
            CANCELLED_REQUEST,
            PORTABILITY_REQUEST_CANCELLED
        ],
		label: "partner:history.on-going-filters.cancelled",
	}
]

export const confirmedHistoryOperationNamesList = [
	{
		id: "all",
		value: historyTypes.backAndBuy.operationNameList,
		label: "partner:history.confirmed-filters.all"
	},
	{
		id: "backtostore-confirmed",
		value: [
            BACKSTOSTORE_REQUEST_ACCEPTED
        ],
		label: "partner:history.confirmed-filters.backtostore-confirmed"
	},
	{
		id: "buy-confirmed",
		value: [
            BUY_REQUEST_ACCEPTED
        ],
		label: "partner:history.confirmed-filters.buy-confirmed"
	},
	{
		id: "backtostore-forced",
		value: [
            BACKSTOSTORE_REQUEST_FORCED
        ],
		label: "partner:history.confirmed-filters.backtostore-forced"
	},

]